import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";

export interface ISavedReport extends ISavedListFilter {
    reportId: string;
    reportFilter: any;
    showInFrontPage: boolean;
}

export class SavedReport extends SavedListFilter implements ISavedReport {
    reportId: string;
    reportFilter: any;
    showInFrontPage: boolean;

    constructor();
    constructor(obj: ISavedReport);
    constructor(obj?: any) {
        super(obj);
        this.reportId = obj && obj.reportId || "";
        if (obj && obj.reportFilter) {
            this.reportFilter = obj.reportFilter;
        }
        this.showInFrontPage = obj && obj.showInFrontPage || false;
    }

    getHash(): string {
        return super.getHash() + "#" + this.reportId + "#" + JSON.stringify(this.reportFilter) + "#" + this.showInFrontPage.toString();
    }
}